<template>
  <section id="neubau">
    <v-container>

      <v-row justify="center">
        <h2 class="section-title">{{ lang.neubau.caption }}</h2>
      </v-row>

      <v-row justify="center" align="center" class="text-center mt-8">
        <v-col cols="12" md="5" v-for="item in lang.neubau.items" :key="item.caption" class="neubau-liste">
          <v-icon size="40" class="primary-color mb-3">{{ item.icon }}</v-icon>
          <h3 class="text-h6 font-weight-medium mb-2">{{ item.caption }}</h3>
          <p class="mb-6">{{ item.description }}</p>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-6">
        <v-col cols="12" md="8" class="text-center">
          <v-btn class="text-white primary" size="large" href="#contact">{{ lang.neubau.button_to_contact_link }}</v-btn>
        </v-col>
      </v-row>

    </v-container>
  </section>
</template>

<style>
@media (min-width: 960px) {
  .neubau-liste {
    max-width: 600px !important;
  }
}
</style>

<script>
import lang from '@/lang/lang.js'

export default {
  data() {
    return {
      lang: lang,
    }
  }
}
</script>